// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xsmallOnWide-superElipse-f5416dbf","strokeWidth":"super-ellipse-skins-xsmallOnWide-strokeWidth-edfdd320"};